import Vue from "vue";
import Router from "vue-router";
// import {menulist} from "@/common/js/menu.js";
// import {cookie} from '@/common/js/public';

//路由集合
import home from './home';
import station from './station';
import goods from './goods';
import members from './members';
import business from './business';
import deal from './deal';
import permit from './permit';
import card from './card';
import market from './market';
import couponactivities from './couponactivities';
import settleAccounts from './settleAccounts';
import statistics from './statistics';
import system from './system';
import log from './log';
import categoryRoute from './category';
import shoppingguide from './shoppingguide';
import content from './content';
import count from './count';
import customservice from './customservice';
import liveBroadcast from './liveBroadcast';
import anchor from './anchorManage';
import smartScreen from './smartScreen';
import cash from './cash';
import matterManage from './matterManage.js'
import retail from './retailStore.js'
import distributor from './distributor';
import moneySavingCard from './moneySavingCard';
import newUser from './newUser';
import partner from './partner';
import channerAdmin from './channelAdmin'
import giftBag from './giftBag'
import valetOrder from './valetOrder'

Vue.use(Router);

const router = new Router({
  routes: [{
      path: "/login",
      name: "login",
      component: () =>
        import ("@/pages/login/login")
    },
    {
      path: "/",
      component: () =>
        import ("@/pages/index"),
      children: [
        ...home,
        ...station,
        ...goods,
        ...members,
        ...business,
        ...deal,
        ...permit,
        ...card,
        ...market,
        ...couponactivities,
        ...settleAccounts,
        ...statistics,
        ...system,
        ...categoryRoute,
        ...log,
        ...shoppingguide,
        ...content,
        ...count,
        ...customservice,
        ...liveBroadcast,
        ...cash,
        ...smartScreen,
        ...anchor,
        ...matterManage,
        ...retail,
        ...distributor,
        ...moneySavingCard,
        ...newUser,
        ...channerAdmin,
        ...partner,
        ...giftBag,
        ...valetOrder
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // let token = cookie.get('token');
  let token = window.sessionStorage.getItem('token');
  if (token || to.name == 'login') {
    
  } else {
    router.push('/login')
  }
  next();

});

export default router;